
/*
*
* File JS componente Gallery
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery-bundle.min.css';

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './gallery.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const gallery = () => {

    let allBoxGallery = document.querySelectorAll('.gallery');

    if(!allBoxGallery.length) return;

    allBoxGallery.forEach(el => {
        let thisGallery = el.querySelector('.lightgallery');
        let openGallery = el.querySelector('.gallery__image');
        
        if(thisGallery) 
        {
            lightGallery(thisGallery, {
                thumbnail: false,
                animateThumb: false,
                showThumbByDefault: false,
                download: false,
                hideBarsDelay: 1000000000,
                autoplayControls: false,
                hash: false,
                escKey: true,
                keyPress: true,
                licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB'
            });

            openGallery.addEventListener('click', (evt, el) => {
                evt.preventDefault();
                thisGallery.querySelector('l').click()
            })
        }
    });
}



export default gallery;

//--------------------------------------------------------------------//